<template>
	<div class="am-full-gallery">
		<div class="am-full-gallery__close" @click="$emit('close', $event)">
			<am-text type="button">
				Fechar
			</am-text>
			<am-button-icon
				name="close"
			/>
		</div>

		<div class="am-full-gallery__swiper swiper-container">
			<div class="am-full-gallery__wrapper swiper-wrapper">
				<div
					class="am-full-gallery__slide swiper-slide"
					v-for="image in images"
				>
					<div class="am-full-gallery__container">
						<img class="am-full-gallery__image" :src="getSrc(image)">

						<am-text class="am-full-gallery__caption" v-if="image.caption">
							{{ image.caption }}
						</am-text>
					</div>
				</div>
			</div>
		</div>

		<am-control
			class="am-full-gallery__control"
			@prev="onPrev"
			@next="onNext"
			v-if="images.length > 1"
		/>
	</div>
</template>

<script>
import AMText from '@/components/atoms/AMText'
import AMButtonIcon from '@/components/molecules/AMButtonIcon'
import AMControl from '@/components/molecules/AMControl'
import Swiper from 'swiper'

export default {
	components: {
		'am-text': AMText,
		'am-button-icon': AMButtonIcon,
		'am-control': AMControl
	},

	props: {
		current: {
			type: Number,
			default: 0
		},
		images: {
			type: Array|Object,
			default: () => ([
				'https://placeimg.com/1024/768/any',
				'https://placeimg.com/640/480/nature',
				'https://placeimg.com/800/600/nature',
				'https://placeimg.com/1024/768/nature',
				'https://placeimg.com/640/480/tech',
				'https://placeimg.com/800/600/tech',
				'https://placeimg.com/1024/768/tech',
				'https://placeimg.com/640/480/people',
				'https://placeimg.com/800/600/people',
				'https://placeimg.com/1024/768/people',
				'https://placeimg.com/640/480/any',
				'https://placeimg.com/800/600/any',
				'https://placeimg.com/1024/768/any',
				'https://placeimg.com/640/480/nature',
				'https://placeimg.com/800/600/nature',
			])
		}
	},

	data: () => ({
		swiper: null
	}),

	mounted() {
		this.swiper = new Swiper(this.$el.querySelector('.am-full-gallery__swiper'), {
			slidesPerView: 1,
			spaceBetween: 24
		})

		this.$nextTick(() => {
			this.swiper.update()

			// Slide to current
			this.swiper.slideTo(this.current)
		})
	},

	destroyed() {
		this.swiper.destroy(true, false)
	},

	methods: {
		onPrev() {
			this.swiper.slidePrev()
		},

		onNext() {
			this.swiper.slideNext()
		},

		getSrc(image) {
			if (typeof image === 'object')
				return image.path
			else
				return image
		}
	}
}
</script>

<style lang="scss">
.am-full-gallery{
	position: relative;
	background: rgba(white, .95);
	&__close{
		position: absolute;
		top: 16px;
		right: 16px;
		display: flex;
		align-items: center;
		z-index: 30;
		.am-text{
			margin-right: 16px;
		}
	}
	&__swiper{
		height: 100%;
	}
	&__slide{
		display: flex;
		align-items: center;
		justify-content: center;
	}
	&__container{
		display: flex;
		flex-flow: column;
		justify-content: center;
		height: 100%;
	}
	&__caption{
		margin-top: 16px;
		text-align: center;
		font-size: 14px;
		color: $c-brown;
	}
	&__image{
		min-width: 300px;
		max-width: 100%;
		max-height: 80%;
	}
	&__control{
		position: absolute;
		bottom: 16px;
		left: 50%;
		transform: translate(-50%, 0);
		z-indeX: 30;
	}

	@include grid-media($desktop-grid) {
		&__caption{
			text-align: left;
		}
	}
}
</style>
